
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.418 8.625a7.083 7.083 0 1014.167 0 7.083 7.083 0 00-14.167 0zm12.879 0a5.796 5.796 0 11-11.591 0 5.796 5.796 0 0111.59 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.439 9.498l3.749-3.75L12.19 6.75l-4.751 4.751-2.626-2.626 1.002-1.001 1.624 1.624z","fill":"#fff"}})])
          )
        }
      }
    